import { Box, Button, Stack, Typography } from '@mui/material';
import { ReactComponent as ReportDownloadIcon } from 'assets/icons/ReportDownload.svg';
import { FINANCIAL_HEALTH_REPORT_URL } from 'const';
import { format } from 'date-fns';
import { sk } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

import { styles } from './FinancialHealthReportWidget.styles';

export const FinancialHealthReportWidget: React.FC = () => {
  const { t } = useTranslation();

  const handleDownloadReport = () => {
    window.open(FINANCIAL_HEALTH_REPORT_URL, '_blank');
  };

  return (
    <Box sx={styles.container}>
      <Stack alignItems="center" direction="row" spacing={2}>
        <ReportDownloadIcon height={48} width={48} />
        <Stack direction="column">
          <Typography variant="bodyStrongL">{t('homepage.financialHealthReportWidget.title')}</Typography>
          <Typography variant="bodyM">
            {t('homepage.financialHealthReportWidget.updateDate', {
              date: format(new Date(), 'dd. MMMM', { locale: sk }),
            })}
          </Typography>
        </Stack>
      </Stack>
      <Button color="tertiaryButton" onClick={handleDownloadReport}>
        <Typography color="blue.dark">{t('homepage.financialHealthReportWidget.download')}</Typography>
      </Button>
    </Box>
  );
};
